<script setup lang="ts">
import clsx from 'clsx';

const props = defineProps<{ class?: string }>();
const classes = clsx('flex h-full min-h-0 flex-col', props.class);
</script>

<template>
  <nav :class="classes"><slot /></nav>
</template>
